import {useState} from "react";
import {ListItem, Text, UnorderedList, VStack} from "@chakra-ui/react";
import {InputStyle, RequestAction, TagUser} from "../../models";
import {ChoiceRadio, L5Button, FormInput} from "../UI"

type SettlingProps = {
    onAction: (a: RequestAction) => void
    onClose: () => void
}
export function DelegationContent(p: SettlingProps) {
    const [users, setusers] = useState<TagUser[]>([]);
    const inputs: InputStyle[] = [
        {
            data: {
                currentValue: users,
                description: "This person will become responsible for " +
                "approving or declining the request.",
                disabled: users.length >= 1,
                label: "New Resolver",
                onAddition: (v) => setusers(users.concat([v])),
                onRemoval: (v) => setusers(users.filter((u) => u.email !== v)),
                placeholder: "Add name or email"
            },
            type: "users"
        },
    ];
    function submit() {
        p.onClose();
        p.onAction({data: {email: users[0].email}, type: "reassign"});
    }
    return <>
        <VStack flex="2 1 auto" gap="1rem" alignItems="stretch">
            <Text>
                Resolution requests can only be resolved by one person at a time.
                If you’re not the right person to decide, assign someone else to take responsibility.
            </Text>
            {inputs.map((v, idx) => <FormInput key={idx} {...v}/>)}
            <div className="stack">
                <Text fontWeight="bold" textTransform="capitalize" fontSize="1.1em">Once reassigned: </Text>
                <UnorderedList spacing={3} px=".25rem">
                    <ListItem>You'll no longer be able to resolve this request</ListItem>
                    <ListItem>The new resolver will be notified</ListItem>
                </UnorderedList>
            </div>
        </VStack>
        <L5Button type="primary" onClick={submit} isDisabled={users.length <=0}>
            Assign Resolver
        </L5Button>
        <L5Button type="secondary" onClick={p.onClose}>
            Cancel
        </L5Button>
    </>;
}

export function ResolutionContent(p: SettlingProps) {
    const [choice, setChoice] = useState<string|undefined>(undefined);
    const [note, setNote] = useState<string|undefined>(undefined);
    const choices = [
        {value: "accept", title: "Proceed with this request"},
        {value: "decline", title: "Do not proceed"}
    ];
    function submit() {
        const options = choices.map((c) => c.value);
        if (options.includes(choice ?? "")) {
            p.onClose();
            p.onAction(
                {data: {note, proceed: choice === "accept"}, type: "resolve"}
            );
        }
    }
    return <>
        <VStack flex="2 1 auto" alignItems="stretch" gap="1rem">
            <ChoiceRadio
                flexDir="column"
                title="Request Decision"
                subtitle="Your decision will be recorded with time and participants."
                choices={choices}
                currentChoice={choice}
                fontWeight="normal"
                onUpdate={(v) => setChoice(v)}
            />
            <FormInput
                type="textarea"
                data={{
                    borderRadius: "8px",
                    currentValue: note ?? "",
                    description: "Provide context for your decision. This " +
                    "will be included in the record.",
                    label: "Add a note (Optional)",
                    mh: 100,
                    onUpdate: setNote,
                    placeholder: "Type your note here..."
                }}
            />
        </VStack>
        <L5Button type="primary" onClick={submit} isDisabled={!choice}>
            Record Decision
        </L5Button>
        <L5Button type="secondary" onClick={p.onClose}>
            Cancel
        </L5Button>
    </>;
}
